<script setup lang="ts"></script>

<template>
  <div class="flex h-screen w-screen items-center justify-center">
    <QSpinner
      size="xl"
      style="color: var(--purple)"
    />
    <slot />
  </div>
</template>
